// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2JJRo","content":"RecentSearches_content__3wO3F"};